/**
 * Vrátí hodnotu nebo výchozí hodnotu.
 *
 * @param value - Hodnota.
 * @param defaultValue - Výchozí hodnota.
 * @return Hodnota nebo výchozí hodnota.
 * @ignore
 */
export function valueOrDefault<T>(value: T | undefined, defaultValue: T): T {
    return value !== undefined ? value : defaultValue;
}
